module.exports = __webpack_public_path__ + "img/15ne.e364eafc.svg";